<template>
    <div>
        <b-modal ref="FontLibraryClient" id="FontLibraryClient" scrollable size="md" title="My Font Library">

            <p>List of all the fonts used in apps throughout your site.</p>

            <table outlined class="table">
                <thead>
                    <tr>
                        <th scope="col">Font Name</th>
                        <th scope="col" class="text-right">Action</th>
                    </tr>
                </thead>
                <tbody v-for="(font,index) in googleFontsArray" :key="index">
                    <tr>
                        <td>{{font}}</td>
                        <td class="text-right">
                            <i class="far fa-trash-alt delete-font"
                            v-b-tooltip.hover :title="'Delete: '+font"
                            @click="deleteStageOne(font)"></i>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-show="showConfirmDeleteMsg" class="confirm-delete-msg">
        
                <div class="confirm-delete-msg--title">Globally delete <span>{{deleteFont}}</span>?</div>
                <b-button variant="danger" @click="deleteFontFromClientArray()">Delete</b-button>
                <b-button variant="light" @click="cancelDeleteFont">Cancel</b-button>

                <div class="confirm-delete-msg--info">This action will remove the font from your site, make sure you are not using it in other apps from our bundle.</div>

            </div>

            <div slot="modal-footer">
                 <b-button variant="primary" :disabled="settingsFromWeebly.disableAddMoreFontsBtn" v-b-modal="'FontLibrary'" size="sm">Add more fonts</b-button>
            </div>
            
        </b-modal>
        

    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'clientFontLibrary',

    data() {
        return{
            fontList: '',
            deleteFont: '',
            showConfirmDeleteMsg: false
        }
    },

    methods: {

        deleteStageOne(font) {

            // scroll up parent 
            var scrollBody = document.getElementById('FontLibraryClient___BV_modal_body_');
            scrollBody.scrollTo(0,0);
            scrollBody.style.overflowY = 'hidden';

            // disable add more fonts button from footer
            this.$store.state.disableAddMoreFontsBtn = true

            // set font for deletion
            this.deleteFont = font

            // show delete confirm
            this.showConfirmDeleteMsg = true

        },

        cancelDeleteFont() {
            // activate add more fonts button from footer
            this.$store.state.disableAddMoreFontsBtn = false

            // hide delete stage one message
            this.showConfirmDeleteMsg = false

            // scroll  parent 
            var scrollBody = document.getElementById('FontLibraryClient___BV_modal_body_');
            scrollBody.style.overflowY = 'auto';

        },

        deleteFontFromClientArray() {
            this.$store.state.googleFontsToLoad.splice( this.$store.state.googleFontsToLoad.indexOf(this.deleteFont), 1 )

            // hide delete confirmation again
            this.showConfirmDeleteMsg = false

            // scroll  parent 
            var scrollBody = document.getElementById('FontLibraryClient___BV_modal_body_');
            scrollBody.style.overflowY = 'auto';
            console.log('fonts: ' ,this.$store.state.googleFontsToLoad)

            this.updateFontsOnServer()

        },

        updateFontsOnServer() {
            let fd = new FormData();
            
            fd.append('fonts', this.$store.state.googleFontsToLoad)
            fd.append('jwt-token', this.$store.state.jwtToken)

            console.log('fonts updating server: ' ,this.$store.state.googleFontsToLoad)
            
            axios.post('https://www.appjustable.com/weebly/app_in_process/buttons/update_fonts.php',fd)
            .then((response)=> {
                console.log(response)
                this.$refs['FontLibrary'].hide()
            }).catch( (error)=> {
                console.log(error)
            })
        }
        
    },

    computed: {

        googleFontsArray() {

            return this.$store.state.googleFontsToLoad

        },

        settingsFromWeebly() {

            return this.$store.state.weeblySettings

        }

    },
    mounted() {
        setTimeout(()=> {
            console.log('it should have them all ',this.fontList)
        }, 2000)
        
    }
}

</script>

<style lang="less">
    @import '../../../less/colors.less';

    #FontLibraryClient {

        .table thead th {
            vertical-align: bottom;
            border-bottom: 1px solid @border_grey_medium;
            background: #f1f3f7;
        }

        .table {
            border: 1px solid @border_grey_medium;
        }
    }

    .delete-font {
        cursor: pointer;
        padding: 5px 12px;

        &:hover {
            color: @warning_red;
        }
    }

    .confirm-delete-msg {
        background: #fff;
        padding: 15px;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;

        .confirm-delete-msg--info {
            text-align: left;
            margin-top: 30px;
        }

        .delete-info-msg {
            position: absolute;
            top: 7px;
            right: 7px;
        }

        .confirm-delete-msg--title {
            color: @title_grey;
            font-size: 17px;
            margin-bottom: 1em;

            span {
                font-weight: 700;
            }
        }

        button {
            margin: 0 7px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/elements/elementSettings/FontLibraryClient.vue